import React, { useContext } from 'react';
import { Link } from "react-router-dom";
import { GlobalContext } from '../../contexts/GlobalContext';
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb';
import './About.css'
import Divider from '../../components/Divider/Divider';
import PageTitle from '../../components/PageTitle/PageTitle';
import CardVision from '../../components/CardVision/CardVision';
import { primary } from '../../theme/colors';
import CardImgDistribution from '../../components/CardImgDistribution/CardImgDistribution';
import CardInfoIcon from '../../components/CardInfoIcon/CardInfoIcon';


const About = () => {
    const { state } = useContext(GlobalContext);
    const language = state.language || 'pt-br';
    const data = require(`../../assets/languages/${language}/about.json`);
    const {
        intro,
        breadcrumb,
        selectedPage,
        breadCrumbImage,
        vision,
        visionCards,
        competitiveAdvTitle,
        competitiveAdvContent,
        competitiveAdvContentList1,
        competitiveAdvContentList2,
        structureBtu,
        structureBtuList,
        distributionTitle,
        distributionContent,
        distributionIntro,
        distributionCards,
        transportWhitBacIntro,
        transportWhitBacLink,
        textLink,
        link
    } = data

    const TransportWhitBac = () => {
        return (
            <div className='about-transport-whit-bac-container mg-bot-100'>
                <div>
                    <span className='text-title-secondary'>{transportWhitBacIntro}</span>
                    <span>{transportWhitBacLink} <Link to={link}>{textLink}</Link></span>
                </div>
            </div>
        )
    }

    return (
        <>
            <Breadcrumb
                beforeRoutes={breadcrumb}
                selectedPage={selectedPage}
                classColor='white100'
                image={breadCrumbImage}

            />
            <div className='main-container mg-top-100 mg-bot-100'>
                <section className="section-container">
                    <div className='container-about-intro'>
                        <div className='about-intro'>
                            <span dangerouslySetInnerHTML={{ __html: intro }} className='text-primary text-intro'></span>
                            <Divider width='60%' margin='30px 0' />
                        </div>
                    </div>

                    <div className='about-vision' id='about-vision'>
                        <PageTitle title={vision} />
                        <div className='container-card-vision'>
                            {visionCards.map((d, i) => {
                                return (
                                    <CardVision key={i} title={d.title} iconName={d.iconName} classColor={d.classColor} content={d.content} _className={d.className} />
                                )
                            })}
                        </div>
                    </div>

                    <div className='competitive-advantages' id='competitive-advantages'>
                        <PageTitle title={competitiveAdvTitle} />
                        <span dangerouslySetInnerHTML={{ __html: competitiveAdvContent }}></span>
                        <div className='container-competitive-advantages-list'>
                            <div className='container-competitive-advantages-list-item d-none'>
                                {competitiveAdvContentList1.map((d, i) => <li key={i}>{d}</li>)}
                            </div>
                            <div className='container-competitive-advantages-list-item d-none'>
                                {competitiveAdvContentList2.map((d, i) => <li key={i}>{d}</li>)}
                            </div>
                        </div>
                    </div>
                    <span dangerouslySetInnerHTML={{ __html: structureBtu }} className='text-primary text-intro mg-bot-20 d-none'></span>

                    <div className='container-card-info d-none'>
                        {structureBtuList.map((d, i) => <CardInfoIcon key={i} iconName={d.iconName} title={d.title} content={d.content} />)}
                    </div>

                </section>
            </div>

            <div className='main-container about-main-distribution mg-bot-100 d-none'>
                <section className="section-container">
                    <PageTitle title={distributionTitle} primaryColor={primary.primary300} />
                    <div className='mg-bot-50'>
                        <span dangerouslySetInnerHTML={{ __html: distributionContent }} className='white100'></span>
                    </div>
                    <span dangerouslySetInnerHTML={{ __html: distributionIntro }} className='text-primary text-intro white100'></span>
                    {distributionCards.map((d, i) => {
                        return <CardImgDistribution key={i} image={d.image} title={d.title} textClassName={d.textClassName} />
                    })}
                </section>
            </div>

            <div className='main-container'>
                <div className="section-container">
                    {TransportWhitBac()}
                </div>
            </div>


        </>

    );
};

export default About;